export const FIND_DOCUMENT_MATCHES = 'FIND_DOCUMENT_MATCHES';
export const SET_DOCUMENT_MATCH = 'SET_DOCUMENT_MATCH';
export const SET_DOCUMENT_MATCHES = 'SET_DOCUMENT_MATCHES';
